export function shouldCloseOnSingleSelect() {
  return true
}
